import Vue from 'vue'

// Firebase Firestore plugin (Vue.$db and Vue.$firestore)
import fbPlugin from '@/firebase/plugin'

import App from './App.vue'
import router from './router'
import store from './store'
import '@/misc/register-service-worker'
import '@/misc/handle-network-status'

import '@/firebase/authentication'
import '@/misc/handle-apple-install-prompt'
import 'pwacompat'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
Vue.use(fbPlugin)
Vue.use(require('vue-moment'))

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
